module.exports = __webpack_public_path__ + "static/3-1b0691c5f74a8744461eaedd65c8f706.png";